module.exports = __webpack_public_path__ + "d5c51b208c54a75cdda24a7d376ec5d9.svg";